import { persica, holidaze, frontalex } from "./imports";

export const SelectedProjects = {
  2: {
    title: "PERSICA",
    type: "School Project",
    hexColor: "E4A15D",
    url: "https://persica-skincare.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/persica",
    image: persica,
    tags: [
      {
        name: "Design",
      },
      {
        name: "Brand Identification",
      },
      {
        name: "Responsive",
      },
      {
        name: "HTML",
      },
      {
        name: "Sass",
      },
      {
        name: "JavaScript",
      },
      {
        name: "API",
      },
      {
        name: "Bootstrap",
      },
      {
        name: "Strapi",
      },
    ],
    description:
      "This was my second semester project at Noroff where I received a B. For this semester project we were to create a responsive e-commerce website that had both customer-facing and admin sections. We could decide the theme ourselves, and I chose to create a website for PERSICA - a skincare brand focusing on organic products. I created the logo, hero banner, and all the products in Adobe Illustrator, and designed the website in Adobe XD. We were also required to make a style guide and functional requirements that I chose to write in the form of 'System-Must-Haves'. The website was created with HTML, Sass and JS.",
  },
  3: {
    title: "holidaze",
    type: "School Project",
    hexColor: "3B527A",
    url: "https://holidaze-norway.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/holidaze",
    image: holidaze,
    tags: [
      {
        name: "Design",
      },
      {
        name: "Brand Identification",
      },
      {
        name: "Responsive",
      },
      {
        name: "ReactJS",
      },
      {
        name: "Sass",
      },
      {
        name: "Bootstrap",
      },
      {
        name: "Strapi",
      },
      {
        name: "BEM",
      },
      {
        name: "API",
      },
    ],
    description:
      "This was my last and final exam project at Noroff where I received an A. For this project we were to take the skills we had learned over the past two years and create a finished product that reflected our general development capabilities, and visual, and technical skills. The task was to create a hotel booking website for a local tourism agency in Bergen. The finished website has two sides - visitor and admin - and both reflects my capabilities as a front-end developer. I created the logo with Adobe Illustrator and I designed the website with Adobe XD. The website was created with ReactJS and Sass.",
  },
  4: {
    title: "Portfolio v1.0",
    type: "School Project",
    hexColor: "7AD0B2",
    url: "https://frontalex.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/frontalex-portfolio",
    image: frontalex,
    tags: [
      {
        name: "ReactJS",
      },
      {
        name: "Sass",
      },
      {
        name: "BEM",
      },
      {
        name: "Design",
      },
      {
        name: "Responsive",
      },
      {
        name: "Bootstrap",
      },
      {
        name: "EmailJS",
      },
      {
        name: "IG Feed",
      },
    ],
    description:
      "This was my first portfolio. I wanted to create a light and modern website with all my information and what I could offer as a frontend developer. I designed it in Adobe XD, and created the website with ReactJS and Sass. I also used the npm packages EmailJS for the contact form and IG Feed for the Instagram Feed.",
  },
};
